







































































































































































// biome-ignore lint/style/useImportType: <explanation>
import {
  CarpsaleManagementCarpsaleService as carpsaleApi,
  CarpsaleManagementListItemRequest,
  ContentsManagerService as contentApi,
  StoreManagementListItemRequest,
  StoreManagementStoreService as storeApi,
} from "@/common/api";
import { HTTP_STATUS_SUCCESS } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import qSelectEvents from "@/components/common/qSelectEvents.vue";
import qSelectLives from "@/components/common/qSelectLives.vue";
import qSelectShows from "@/components/common/qSelectShows.vue";
import uploadFile from "@/components/common/uploadFile.vue";
import { CATEGORIES, CATEGORIES_KEY, CATEGORIES_SHOW } from "@/model/contentUpload";
import _ from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";

@Component({
  name: "ContentsEdit",
  components: {
    uploadFile,
    QErrors,
    vSelect,
    qSelectLives,
    qSelectEvents,
    qSelectShows,
  },
})
export default class ContentsEdit extends Vue {
  get categories() {
    if (this.isAdminOrManager) {
      return CATEGORIES;
    }
    return CATEGORIES_SHOW;
  }
  get isAdminOrManager() {
    return ["admin", "manager"].includes(this.role);
  }

  get isShowEvent() {
    return [
      CATEGORIES_KEY.CATEGORY_EVENT_I,
      CATEGORIES_KEY.CATEGORY_EVENT_M,
    ].includes(this.category);
  }

  get isShowLiveCarp() {
    return [
      CATEGORIES_KEY.CATEGORY_LIVE_I,
      CATEGORIES_KEY.CATEGORY_LIVE_M,
    ].includes(this.category);
  }

  get isShowShow() {
    return [CATEGORIES_KEY.CATEGORY_EVAL_I].includes(this.category);
  }

  get koiCodes() {
    if (this.isShowEvent && this.event) {
      return this.event.codes;
    }
    if (this.isShowLiveCarp && this.liveCarp) {
      return this.liveCarp.codes;
    }
    if (this.isShowShow && this.selectedShow) {
      return this.selectedShow.codes;
    }
    return [];
  }

  get isShowYoutubeTitle() {
    return this.category === CATEGORIES_KEY.CATEGORY_OTHER_M;
  }

  get filesWithoutSuccess() {
    return this.files.filter((item) => item.status !== "success");
  }
  @Prop({ type: String, default: "" })
  public role!: string;

  public isShow = false;

  public errorStyle = {
    maxWidth: "100%",
  };
  public category = null;
  public event = null;
  public liveCarp = null;
  public selectedShow = null;
  public youtubeTitle = null;
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  public errors: any = {};
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  public files: any = [];
  public uploadFileIndex = null;
  public uploading = false;
  public hasErrorFiles = false;
  public isCreate = false;
  public uploadFiles = [];
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  public form: any = {
    title: "",
  };
  public allowSequentialNumbering = false;

  public uploadOptions = {
    acceptedFiles: ".jpg, .jpeg, .png, .mp4, .pdf",
    maxFilesize: 5, // 5mb
  };

  @Watch("category", { deep: true })
  public watchFileInput() {
    if (
      [
        CATEGORIES_KEY.CATEGORY_LIVE_M,
        CATEGORIES_KEY.CATEGORY_EVENT_M,
        CATEGORIES_KEY.CATEGORY_CARP_M,
        CATEGORIES_KEY.CATEGORY_OTHER_M,
      ].includes(this.category)
    ) {
      this.uploadOptions.acceptedFiles = ".mp4";
      this.uploadOptions.maxFilesize = 1024;
    } else {
      this.uploadOptions.acceptedFiles = ".jpg, .jpeg, .png";
      this.uploadOptions.maxFilesize = 5;
    }
    if (
      [
        CATEGORIES_KEY.CATEGORY_EVENT_I,
        CATEGORIES_KEY.CATEGORY_LIVE_I,
        CATEGORIES_KEY.CATEGORY_STORE_I,
        CATEGORIES_KEY.CATEGORY_CARP_I,
      ].includes(this.category)
    ) {
      this.allowSequentialNumbering = true;
    } else {
      this.allowSequentialNumbering = false;
    }
    (this.$refs.myVueDropzone as uploadFile).reCreateDropzone();
  }

  public show() {
    this.initData();
    this.isShow = true;
  }

  public async initData() {
    this.errors = {};
    this.category = this.role != "show_staff" ? CATEGORIES_KEY.CATEGORY_LIVE_M : CATEGORIES_KEY.CATEGORY_EVAL_I;
    this.files = [];
    this.isCreate = false;
    this.event = null;
    this.liveCarp = null;
    this.selectedShow = null;
    this.youtubeTitle = null;
    this.uploadFiles = [];
  }

  public removeFile(index) {
    (this.$refs.myVueDropzone as uploadFile).removeFile(
      this.files[index],
      index,
    );
  }

  public pushError(message) {
    this.errors = {
      ...this.errors,
      ...{ uploadFiles: message },
    };
  }
  public changeFile(files) {
    this.files = files;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public async upload() {
    this.errors = {};
    this.uploadFiles = [];
    try {
      if (!this.validateFile()) {
        return;
      }
      await (this.$refs.myVueDropzone as uploadFile).uploadToS3(
        this.filesWithoutSuccess,
      );
    } catch (error) {
      if (!error.body) {
        qNotify.error({
          text: "アップロードに失敗しました。オフラインの可能性があります。",
        });
        return;
      }
      qNotify.error({
        text: error.body.message,
      });
    }
  }

  public async successUpload(file) {
    const key = this.files.findIndex((row) => {
      return row.filePath === file.filePath;
    });
    if (key < 0) {
      return;
    }
    this.uploadFiles = [
      ...this.uploadFiles,
      {
        extension: file.extension,
        filePath: file.filePath,
        filename: file.upload.filename,
        size: file.upload.bytesSent,
        mimeType: file.mimeType,
      },
    ];
    let parameters = {
      category: this.category,
      uploadFiles: this.uploadFiles,
      youtubeTitle: this.youtubeTitle,
    };
    if (this.isShowEvent) {
      parameters = {
        ...parameters,
        ...{
          eventId: this.event.id,
        },
      };
    }
    if (this.isShowLiveCarp) {
      parameters = {
        ...parameters,
        ...{
          livecarpId: this.liveCarp.id,
        },
      };
    }
    if (this.isShowShow) {
      parameters = {
        ...parameters,
        ...{
          showId: this.selectedShow.id,
        },
      };
    }

    if (this.isCreate) {
      const result = await contentApi
        .adminContentsCreate(parameters)
        .catch((error) => {
          if (error.status >= 500) {
            error.status = "error";
          }
          return error.body;
        });

      if (result.status === HTTP_STATUS_SUCCESS) {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
      } else if (result.status === "error") {
        this.errors = result.errors;
        for (const k of Object.keys(result.errors)) {
          const _row = result.errors[k];
          const key = this.files.findIndex((row) => {
            return row.filePath === _row.filePath;
          });
          this.files[key].status = "error";
          this.files[key].error = "error";
        }
      } else {
        qNotify.error({
          text: result.message,
        });
      }
      if (this.files.every((row) => row.status === "success")) {
        this.$emit("close");
        this.close();
      }
    }
  }

  public async allowCreate(status) {
    this.isCreate = status;
  }
  public uploadStatus(flag) {
    this.uploading = flag;
  }

  public close() {
    this.isShow = false;
    this.files = [];
    this.youtubeTitle = "";
    (this.$refs.myVueDropzone as uploadFile).reset();
  }

  public validateFile() {
    const files = [...this.files];
    switch (this.category) {
      case CATEGORIES_KEY.CATEGORY_EVENT_I:
      case CATEGORIES_KEY.CATEGORY_LIVE_I:
        return this.carpsMultiValidate(files);
      case CATEGORIES_KEY.CATEGORY_EVENT_M:
      case CATEGORIES_KEY.CATEGORY_LIVE_M:
      case CATEGORIES_KEY.CATEGORY_EVAL_I:
        return this.carpsSingleValidate(files);
      case CATEGORIES_KEY.CATEGORY_STORE_I:
        return this.storeValidate(files);
      case CATEGORIES_KEY.CATEGORY_CARP_I:
      case CATEGORIES_KEY.CATEGORY_CARP_M:
        return this.carpsaleValidate(files);

      case CATEGORIES_KEY.CATEGORY_OTHER_M:
        return this.otherValidate();
    }
  }

  public otherValidate() {
    let hasErrors = false;
    if (!this.youtubeTitle || this.youtubeTitle.length === 0) {
      hasErrors = true;
      this.errors = {
        ...this.errors,
        ...{
          youtubeTitle: ["Youtube タイトルは必須です。"],
        },
      };
    } else if (this.youtubeTitle.length > 28) {
      hasErrors = true;
      this.errors = {
        ...this.errors,
        ...{
          youtubeTitle: ["Youtube タイトルは28文字以下にしてください。"],
        },
      };
    }

    return !hasErrors;
  }

  public carpsMultiValidate(files) {
    let hasErrors = false;
    for (const [index, file] of files.entries()) {
      let filename = file.upload.filename as string;
      let firstPart = filename.slice(0, Math.max(0, filename.indexOf(".")));
      const extension = filename.slice(
        Math.max(0, filename.indexOf(".")),
        filename.length,
      );
      // サフィックスなしは登録不可 @see https://qumitai.backlog.jp/view/NARITA_KOI-803
      if (!firstPart.includes("_")) {
        files[index].upload.filename = `${firstPart}_01${extension}`;
        filename = files[index].upload.filename;
        firstPart = filename.slice(0, Math.max(0, filename.indexOf(".")));
      }
      const lastUnderscoreIndex = filename.lastIndexOf("_");
      const lastDotIndex = filename.lastIndexOf(".");
      const numericalOrder = filename.slice(
        lastUnderscoreIndex + 1,
        lastDotIndex,
      );
      const length_ = firstPart.indexOf("_");
      const koiCode = firstPart.slice(0, Math.max(0, length_));
      if (!this.koiCodes.includes(koiCode)) {
        file.error = true;
        hasErrors = true;
        this.errors.uploadFiles[
          index
        ] = `${filename} の鯉コードは登録されていません。`;
      }
      const pattern = /^0\d$|^[1-9]\d$/;
      if (!pattern.test(numericalOrder)) {
        file.error = true;
        hasErrors = true;
        this.errors.uploadFiles[
          index
        ] = `${filename} 連番は2桁で名前をつけてください。`;
      }
    }
    this.files = [...files];
    this.hasErrorFiles = hasErrors;

    return !hasErrors;
  }

  public carpsSingleValidate(files) {
    let hasErrors = false;
    let number = 0;
    for (const file of files) {
      const filename = file.upload.filename as string;
      const firstPart = filename.slice(0, Math.max(0, filename.indexOf(".")));
      const length_ = firstPart.length;
      const koiCode = firstPart.slice(0, Math.max(0, length_));
      if (!this.koiCodes.includes(koiCode)) {
        file.error = true;
        hasErrors = true;
        this.errors.uploadFiles[
          number
        ] = `${filename} の鯉コードは登録されていません。`;
        number++;
      }
    }
    this.files = [...files];
    this.hasErrorFiles = hasErrors;

    return !hasErrors;
  }

  public async storeValidate(files) {
    let hasErrors = false;
    const codes = [];
    let number = 0;
    for (const file of files) {
      let filename = file.upload.filename as string;
      let firstPart = filename.slice(0, Math.max(0, filename.indexOf(".")));
      const extension = filename.slice(
        Math.max(0, filename.indexOf(".")),
        filename.length,
      );
      // サフィックスなしは登録不可 @see https://qumitai.backlog.jp/view/NARITA_KOI-803
      if (!firstPart.includes("_")) {
        filename = `${firstPart}_01${extension}`;
        file.upload.filename = `${firstPart}_01${extension}`;
        filename = file.upload.filename;
        firstPart = filename.slice(0, Math.max(0, filename.indexOf(".")));
      }
      const length_ = firstPart.indexOf("_");
      const itemCode = firstPart.slice(0, Math.max(0, length_));
      codes.push(itemCode);
      file.code = itemCode;
      number++;
    }
    const items = (
      await storeApi.adminStore({
        codes: codes.join(","),
        perPage: 100,
      } as StoreManagementListItemRequest)
    ).data.items;
    number = 0;
    for (const code of codes) {
      const exist = _.some(items, ($row) => $row.code === code);

      if (!exist) {
        this.files.map((row) => {
          if (row.code === code) {
            row.error = true;
          }
        });
        hasErrors = true;
        this.errors.uploadFiles[
          number
        ] = `${code} の商品コードは登録されていません。`;
      }
      number++;
    }

    this.files = [...files];
    this.hasErrorFiles = hasErrors;

    return !hasErrors;
  }

  public async carpsaleValidate(files) {
    let hasErrors = false;
    const codes = [];
    let number = 0;
    if (this.category === CATEGORIES_KEY.CATEGORY_CARP_I) {
      for (const file of files) {
        let filename = file.upload.filename as string;
        let firstPart = filename.slice(0, Math.max(0, filename.indexOf(".")));
        const extension = filename.slice(
          Math.max(0, filename.indexOf(".")),
          filename.length,
        );
        if (!firstPart.includes("_")) {
          filename = `${firstPart}_01${extension}`;
          file.upload.filename = `${firstPart}_01${extension}`;
          filename = file.upload.filename;
          firstPart = filename.slice(0, Math.max(0, filename.indexOf(".")));
        }
        const length_ = firstPart.indexOf("_");
        const itemCode = firstPart.slice(0, Math.max(0, length_));
        file.code = itemCode;
        codes.push(itemCode);
        number++;
      }
    }
    const items = (
      await carpsaleApi.adminCarpsale({
        codes: codes.join(","),
        perPage: 100,
      } as CarpsaleManagementListItemRequest)
    ).data.items;
    number = 0;
    for (const code of codes) {
      const exist = _.some(items, ($row) => $row.code === code);

      if (!exist) {
        this.files.map((row) => {
          if (row.code === code) {
            row.error = true;
          }
        });
        hasErrors = true;
        this.errors.uploadFiles[
          number
        ] = `${code} の商品コードは登録されていません。`;
      }
      number++;
    }

    this.files = [...files];
    this.hasErrorFiles = hasErrors;

    return !hasErrors;
  }
}
